import { Routes, Route } from "react-router-dom";
import LocalTransportListScreen from "screens/App/CRM/LocalTransport/LocalTransportListScreen";
import LocalTransportDetailScreen from "screens/App/CRM/LocalTransport/LocalTransportDetailScreen";
import LocalTransportEditScreen from "screens/App/CRM/LocalTransport/LocalTransportEditScreen";
import LocalTransportCreateScreen from "screens/App/CRM/LocalTransport/LocalTransportCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";
import LocalTransportPrintCard from "screens/App/CRM/LocalTransport/LocalTransportComponents/LocalTransportPrintCard";

const LocalTransportRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<LocalTransportListScreen />} />
      <Route path="create" element={<LocalTransportCreateScreen />} />
      <Route path=":id/detail" element={<LocalTransportDetailScreen />} />
      <Route path=":id/edit" element={<LocalTransportEditScreen />} />
      <Route path=":id/print" element={<LocalTransportPrintCard />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default LocalTransportRouter;
